export enum EnumLanguage {
    ru = 'ru',
    en = 'en',
    cn = 'cn'
}